@if (rollDice) {
  <div class="row">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div class="col-sm-offset-5 col-sm-1">
      <ep-egg-dice></ep-egg-dice>
    </div>
  </div>
}
@if (showSnake) {
  <ep-egg-snake></ep-egg-snake>
}
@if (showProductTeam) {
  <ep-egg-starwars></ep-egg-starwars>
}
@if (showPacman) {
  <ep-egg-pacman></ep-egg-pacman>
}

<div [hidden]="rollDice || showProductTeam || showSnake || showPacman">
  <div class="pageheader">
    <div class="page-title">
      <h1>Partner Search</h1>
      <div class="btn-group" data-toggle="buttons">
        <button class="btn btn-link" id="btnNew" *bizPermissionRequired="'Partner_Action_PartnerCreate'" (click)="createNew()">Create new <ep-svg-icon icon="plus"></ep-svg-icon></button>
      </div>
    </div>
    <restricted-search-callout [visible]="isSearchResultRestricted"></restricted-search-callout>
    <restricted-search-callout [visible]="isSearchMaxResultReached" text="Not all results are displayed below. Please try filtering your search."></restricted-search-callout>
  </div>
  <div class="container container-search">
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-8">
              <input id="partnerSearchfield" type="text" class="form-control" (keyup.enter)="search()" [(ngModel)]="searchSettings.searchString" placeholder="Search..." [readonly]="isSearching" autofocus />
            </div>
            <div class="col-sm-4">
              <div class="search-buttons">
                <button id="btnPartnerSearch" type="button" class="btn btn-primary" (click)="search()" [disabled]="isSearching">Search</button>
                <button id="btnResetSearch" type="button" class="btn btn-secondary" (click)="clear()" [disabled]="isSearching">Reset search</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <ep-tag-selector (selectedTagsChange)="selectedTagsChange($event)" #partnerTagSelector></ep-tag-selector>
        </div>
      </div>
      <div class="col-sm-9">
        <div class="controls-inline">
          <label class="control control-checkbox">
            <input id="chkIncludeLastActivity" type="checkbox" [(ngModel)]="searchSettings.includeLatesDocumentDate" (ngModelChange)="includeLastActivityChange()" placeholder="Search..." [disabled]="isSearching" /><i></i>
            Last Activity
          </label>
          <label class="control control-checkbox">
            <input id="chkOnlyProxyPartners" type="checkbox" [(ngModel)]="searchSettings.onlyProxyPartners" [disabled]="isSearching" /><i></i>
            Proxy Partners
          </label>
          <label class="control control-checkbox">
            <input id="chkAllPartnerOnboarding" type="checkbox" [(ngModel)]="searchSettings.allPartnerOnboarding" [disabled]="isSearching" /><i></i>
            Onboarding Status
          </label>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div class="btn-toolbar form-group">
    <div class="btn-group">
      <button id="showPartnersButton" class="btn btn-link btn-sm" *bizPermissionRequired="'Partner_View_PartnerDetails'" [disabled]="$safeNavigationMigration(selectedRows?.length) <= 0" (click)="showPartners()">Show partners</button>
    </div>
    <div class="btn-group">
      <button class="btn btn-link btn-sm" *bizPermissionRequired="'Partner_Action_PartnerExport'" [disabled]="!canExportPartners" (click)="exportPartners()">Export Selected Partners</button>
    </div>
  </div>
  <dx-data-grid biz-grid
    [bizSetStateStoring]="false"
    [selection]='{ mode: "multiple" }'
    [dataSource]='foundPartners'
    [showCollapseAllButton]="true"
    [showIsLoading]="isSearching"
    (onSelectionChanged)='selectionChanged($event)'>
    <!-- Note: Not using bizGrid stateStoring due to issue with storage instance being null when navigating back from details page using breadcrumb -->
    <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="stateStorageKey" savingTimeout="500"></dxo-state-storing>
    <dxi-column dataField="EdiPortalId" caption="Partner Key" dataType="string"></dxi-column>
    <dxi-column dataField="PartnerName" caption="Partner Name" dataType="string" sortOrder="asc"></dxi-column>
    <dxi-column dataField="MainIdentificationValue" caption="Default Identification" dataType="string"></dxi-column>
    <dxi-column dataField="MainIdentificationName" caption="Default Identification Type " dataType="string"></dxi-column>
    <dxi-column dataField="PartnerTypeName" caption="Partner Type" dataType="string"></dxi-column>
    <dxi-column dataField="DecimalMark" caption="Decimal Mark" dataType="string" [visible]="false"></dxi-column>
    <dxi-column dataField="IsProxyPartner" caption="Is Proxy Partner" dataType="boolean" [visible]="showProxyPartnerColumn()"></dxi-column>
    <dxi-column dataField="LatestDocumentDate" caption="Last Activity" dataType="date" [format]="dateFormat" [visible]="false"></dxi-column>
    <dxi-column dataField="PartnerTags" caption="Tags" dataType="string"></dxi-column>
    <dxi-column dataField="PartnerOnboardingStatus" caption="Onboarding Status" dataType="string" [visible]="showPartnerOnboardingColumn()"></dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(foundPartners, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
      <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(foundPartners, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  </dx-data-grid>
</div>
